import _ from 'lodash';
import React from 'react';
import {Field, reduxForm} from 'redux-form';
import classNames from 'classnames';

import {TextField, TextAreaField, NumberField} from 'components/Fields';
import FormField from 'components/FormField';
import {SearchField} from 'components/Fields';
import Label from 'components/Label';
import ErrorBlock from 'components/ErrorBlock';

import {
  MODALS,
  createOneOffChargeReason,
  fetchOneOffChargeReasons
} from 'ducks/oneOffChargeReasons';
import {closeModal} from 'ducks/modals';

import './styles.css';

export const buildXeroAccountSelectizeOption = acc => ({
  value: acc.id,
  label: `${acc.code} - ${acc.name}`
});

const formSubmit = (values, dispatch, props) => {
  const {locationRef} = props;
  const {label, description, amount, account} = values;

  const submitData = {
    label,
    description,
    amount,
    location: locationRef,
    account: _.get(account, 'value')
  };

  const extraActions = [
    () => closeModal(MODALS.CREATE_ONE_OFF_CHARGE_REASON),
    () => fetchOneOffChargeReasons({locationRef})
  ];

  dispatch(createOneOffChargeReason(submitData, extraActions));
};

class CreateOneOffChargeReasonForm extends React.Component<any> {
  render() {
    const {className, error, xeroAccounts} = this.props;

    return (
      <div className="CreateOneOffChargeReasonForm">
        {error && <ErrorBlock>{error}</ErrorBlock>}
        <form className={classNames(className, 'CreateOneOffChargeReasonForm')}>
          <FormField>
            <Label>Label</Label>
            <Field
              name="label"
              component={TextField}
              placeholder="Write a label here..."
            />
          </FormField>
          <FormField>
            <Label>Description</Label>
            <Field
              name="description"
              component={TextAreaField}
              placeholder="Write a description here..."
            />
          </FormField>
          <FormField>
            <Label>Amount</Label>
            <Field
              className="amount"
              name="amount"
              component={NumberField}
              step="0.01"
            />
          </FormField>
          <FormField>
            <Label>Account</Label>
            <Field
              name="account"
              component={SearchField}
              options={xeroAccounts.map(buildXeroAccountSelectizeOption)}
              disabled={xeroAccounts.length <= 1}
            />
          </FormField>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'createOneOffChargeReason',
  onSubmit: formSubmit
})(CreateOneOffChargeReasonForm);
